/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '../../../../../app/components/common/formInput/formInput.component';
import * as i3 from '@angular/forms';
import * as i4 from '../../../../../app/common/directives/trimValueAccessor';
import * as i5 from '../../../../../app/common/directives/onFocus';
const styles_FormInputComponent:any[] = ([] as any[]);
export const RenderType_FormInputComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_FormInputComponent,data:{}});
function View_FormInputComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),0,'label',[['class',
      'control-label text-ellipsis-inline']],[[8,'innerHTML',1]],(null as any),(null as any),
      (null as any),(null as any)))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.label;
    _ck(_v,0,0,currVal_0);
  });
}
export function View_FormInputComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(402653184,1,{model:0}),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),19,'div',[['class','form-group label-floating']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),i0.ɵdid(278528,(null as any),
      0,i1.NgClass,[i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],
      {klass:[0,'klass'],ngClass:[1,'ngClass']},(null as any)),i0.ɵpod({'has-error':0,
      'is-empty':1}),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_FormInputComponent_1)),i0.ɵdid(16384,
      (null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},
      (null as any)),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),7,'input',[['class','form-control'],['onFocusClass','form-group']],
      [[8,'type',0],[1,'data-autofocus',0],[1,'name',0],[1,'placeholder',0],[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],
          [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
          [(null as any),'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i2.FormInputComponent = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,9)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,9).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i0.ɵnov(_v,9)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i0.ɵnov(_v,9)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('input' === en)) {
          const pd_4:any = ((<any>i0.ɵnov(_v,10).ngOnChange($event.target.value)) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i0.ɵnov(_v,15).onFocus($event)) !== false);
          ad = (pd_5 && ad);
        }
        if (('blur' === en)) {
          const pd_6:any = ((<any>i0.ɵnov(_v,15).onBlur($event)) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.value = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i3.DefaultValueAccessor,
      [i0.Renderer2,i0.ElementRef,[2,i3.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),
      i0.ɵdid(16384,(null as any),0,i4.TrimValueAccessor,[i0.Renderer2,i0.ElementRef,
          [2,i3.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),i0.ɵprd(1024,
          (null as any),i3.NG_VALUE_ACCESSOR,(p0_0:any,p1_0:any) => {
            return [p0_0,p1_0];
          },[i3.DefaultValueAccessor,i4.TrimValueAccessor]),i0.ɵdid(671744,[[1,4]],
          0,i3.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i3.NG_VALUE_ACCESSOR]],
          {isDisabled:[0,'isDisabled'],model:[1,'model']},{update:'ngModelChange'}),
      i0.ɵprd(2048,(null as any),i3.NgControl,(null as any),[i3.NgModel]),i0.ɵdid(16384,
          (null as any),0,i3.NgControlStatus,[i3.NgControl],(null as any),(null as any)),
      i0.ɵdid(16384,(null as any),0,i5.OnFocusDirective,[i0.ElementRef,i0.Renderer2],
          {focusClass:[0,'focusClass'],onFocusClass:[1,'onFocusClass']},(null as any)),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          0,'span',[['class','material-input']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted((null as any),[' '])),i0.ɵncd((null as any),
          0),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵted((null as any),[' ']))],
      (_ck,_v) => {
        var _co:i2.FormInputComponent = _v.component;
        const currVal_0:any = 'form-group label-floating';
        const currVal_1:any = _ck(_v,3,0,((((!_co.disabled && (_co.form != (null as any))) && (!_co.model.pristine || _co.form.submitted)) && !_co.model.valid) || _co.hasErrors),
            (_co.stringHelper.isNullOrEmpty(_co.innerValue) && !_co.isPlaceholderNeed));
        _ck(_v,2,0,currVal_0,currVal_1);
        const currVal_2:any = _co.label;
        _ck(_v,6,0,currVal_2);
        const currVal_14:any = _co.disabled;
        const currVal_15:any = _co.value;
        _ck(_v,12,0,currVal_14,currVal_15);
        const currVal_16:any = 'is-focused';
        const currVal_17:any = 'form-group';
        _ck(_v,15,0,currVal_16,currVal_17);
      },(_ck,_v) => {
        var _co:i2.FormInputComponent = _v.component;
        const currVal_3:any = _co.type;
        const currVal_4:any = _co.autofocus;
        const currVal_5:any = _co.name;
        const currVal_6:any = (_co.isPlaceholderNeed? _co.placeholder: '');
        const currVal_7:any = i0.ɵnov(_v,14).ngClassUntouched;
        const currVal_8:any = i0.ɵnov(_v,14).ngClassTouched;
        const currVal_9:any = i0.ɵnov(_v,14).ngClassPristine;
        const currVal_10:any = i0.ɵnov(_v,14).ngClassDirty;
        const currVal_11:any = i0.ɵnov(_v,14).ngClassValid;
        const currVal_12:any = i0.ɵnov(_v,14).ngClassInvalid;
        const currVal_13:any = i0.ɵnov(_v,14).ngClassPending;
        _ck(_v,8,1,[currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9,
            currVal_10,currVal_11,currVal_12,currVal_13]);
      });
}
export function View_FormInputComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),2,'form-input',([] as any[]),
      (null as any),(null as any),(null as any),View_FormInputComponent_0,RenderType_FormInputComponent)),
      i0.ɵprd(5120,(null as any),i3.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.FormInputComponent]),i0.ɵdid(4308992,(null as any),0,i2.FormInputComponent,
          [[2,i3.NG_VALIDATORS],[2,i3.NG_ASYNC_VALIDATORS]],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,2,0);
      },(null as any));
}
export const FormInputComponentNgFactory:i0.ComponentFactory<i2.FormInputComponent> = i0.ɵccf('form-input',
    i2.FormInputComponent,View_FormInputComponent_Host_0,{hasErrors:'hasErrors',type:'type',
        name:'name',label:'label',disabled:'disabled',form:'form',placeholder:'placeholder',
        isPlaceholderNeed:'isPlaceholderNeed',autofocus:'autofocus'},{},['*']);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./compiled/app/components/common/formInput/formInput.component.ngfactory.ts